module.exports = "/images/vendor/flag-icon-css/flags/1x1/fo.svg?329cbed566020b8e0d7a7b87fe977d28";